import React, { useEffect } from 'react';
import MerchantRegistrationForm from 'components/MerchantRegistrationForm';
import type { DocumentUploadId } from 'types/Document';
import DisplayText from 'components/ui-kits/DisplayText';
import ListLayout from 'components/ListLayout';
import {
  Banner,
  FooterNote
} from 'components/UploadMerchantDocument/UploadMerchantDocument.style';
import imgSrc from '../../../assets/imageBannerBeOnline.png';
import { UpperNoteWrapper } from './BeOnline.style';
import { useSelector } from 'react-redux';
import { RootState } from 'app/store';
import { useHistory } from 'react-router-dom';
import { useIsFetching, useQueryClient } from 'react-query';
import { Merchant } from 'types/Merchant';

const SCREEN_NAME = 'be_online';

const tableRows: {
  id: DocumentUploadId;
  label: string;
  isRequired: boolean;
}[] = [
  {
    id: 'be_online_proof_of_registration',
    label:
      'Kbis de l’entreprise* (attestation Urssaf pour les micro-entrepreneurs) de moins de 3 mois',
    isRequired: true
  },
  {
    id: 'be_online_proof_of_id_front',
    label:
      "Pièce d'identité* (Passport, Carte d'identité recto, Titre de séjour recto)",
    isRequired: true
  },
  {
    id: 'be_online_proof_of_id_back',
    label: "Pièce d'identité (Carte d'identité verso, Titre de séjour verso)",
    isRequired: false
  },
  {
    id: 'be_online_proof_of_address',
    label:
      'Justificatif de domicile de moins de 3 mois au nom et à l’adresse de l’entreprise*',
    isRequired: true
  }
];

const additionalNotesAbove = (
  <>
    <Banner>
      <ListLayout>
        <DisplayText
          fontSize="XXXL"
          color="WHITE"
          fontWeight="BOLD"
          margin="3.2rem auto 2rem">
          Activez votre <br /> Boutique en ligne !
        </DisplayText>
        <DisplayText fontSize="XL" color="WHITE" margin="0 0 2rem 0">
          En quelques clics !
        </DisplayText>
      </ListLayout>
    </Banner>
    <UpperNoteWrapper>
      <ListLayout>
        <DisplayText lineHeight="1.5" fontSize="L" margin="4rem 0 0 0">
          Afin{' '}
          <span className="special-text bold">
            d’activer votre site de vente en ligne
          </span>{' '}
          et de commencer à{' '}
          <span className="special-text bold">utiliser le Shop Manager</span>,
          <br /> vous devez valider votre compte en fournissant{' '}
          <span className="special-text bold">certains justificatifs</span>.
        </DisplayText>
        <DisplayText lineHeight="1.5" fontSize="L" margin="4rem 0 0 0">
          Cette étape est essentielle pour{' '}
          <span className="special-text bold">garantir la sécurité</span> et la{' '}
          <span className="special-text bold">transparence</span> de notre
          solution,
          <br /> aussi bien pour vous que pour vos futurs clients.
        </DisplayText>
        <DisplayText fontSize="L" margin="4rem 0 3rem 0" fontStyle="italic">
          Merci de télécharger et soumettre vos documents directement ci-dessous
          :
        </DisplayText>
      </ListLayout>
      <img
        className="decoration-image"
        alt="Achil website in mobile and laptop view"
        src={imgSrc}
      />
    </UpperNoteWrapper>
  </>
);

const additionalNotesBelow = (
  <>
    <ListLayout>
      <FooterNote>
        <DisplayText fontSize="L" color="WHITE">
          Une fois vos justificatifs téléchargés et soumis, <br />
          <span className="bold">notre équipe les vérifiera rapidement</span>.
        </DisplayText>
        <DisplayText fontSize="L" color="WHITE">
          Dès que <span className="bold">tout est validé</span>, votre site de
          vente en ligne sera <br />
          <span className="bold">prêt à accueillir vos premiers clients !</span>
        </DisplayText>
      </FooterNote>
    </ListLayout>
  </>
);

const BeOnline = () => {
  const history = useHistory();
  const { type } = useSelector((state: RootState) => state.subscriptionPlan);
  const queryClient = useQueryClient();
  const dataMerchant = queryClient.getQueryData<Merchant>('getMerchant');
  const isFetching = useIsFetching(['getMerchant']) > 0;

  useEffect(() => {
    if (isFetching) return;

    if (!dataMerchant?.subscription?.id && !type) {
      history.push({
        pathname: '/merchant-registration/plans'
      });
    }
  }, [dataMerchant?.subscription?.id, type, history, isFetching]);

  return (
    <MerchantRegistrationForm
      tableRows={tableRows}
      screenName={SCREEN_NAME}
      doneStatusLabelButton="En ligne"
      icon="✅"
      additionalNotesAboveTable={additionalNotesAbove}
      additionalNotesBelowTable={additionalNotesBelow}
    />
  );
};

export default BeOnline;
